import { makeStyles, Theme } from "@material-ui/core";
import * as React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import TopBar from "./components/TopBar";
import Drawer from "./components/Drawer";
import OrderList from "./OrderList";
import ItemList from "./ItemList";
import ItemEdit from "./ItemEdit";
import Config from "./Config";
import DouaneList from "./DouaneList";
import DouaneEdit from "./DouaneEdit";
import DouaneDeclaration from "./DouaneDeclaration";
import UserList from "./UserList";
import ArchiveList from "./ArchiveList";
import Picking from "./Picking";
import PickingList from "./PickingList";
import SyncList from "./SyncList";
import Sync from "./Sync";
import SyncConfig from "./SyncConfig";
import { useApiClient, useMessagesClient, useOrg, useStore } from "lib/store";
import { actionUpdateOrg } from "lib/store/Actions";

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: "flex",
    width: "auto",
    height: "100%",
  },
  content: {
    minWidth: 0,
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(2) + 65,
  },
}));

const Main: React.FC = () => {
  const [, dispatch] = useStore();
  const msg = useMessagesClient();
  const api = useApiClient();
  const { org } = useOrg();
  const classes = useStyles();

  React.useEffect(() => {
    msg.onOrgUpdated(() => {
      api
        .GET("/api/orgs/{org}", {
          params: { path: { org: org } },
        })
        .then((r) => {
          if (!r.error) {
            const org = r.data;
            dispatch(actionUpdateOrg(org));
          }
        });
    });
    return () => {
      msg.onOrgUpdated(undefined);
    };
  }, [msg, dispatch, org, api]);

  return (
    <div className={classes.main}>
      <Router>
        <Drawer />
        <TopBar />
        <div className={classes.content}>
          <Route path="/orders/:id?" exact component={OrderList} />
          <Route path="/archives/:id?" exact component={ArchiveList} />
          <Route path="/items" exact component={ItemList} />
          <Route path="/item/:id?" exact component={ItemEdit} />
          <Route path="/config" exact component={Config} />
          <Route path="/douanes" exact component={DouaneList} />
          <Route path="/douane/:id?" exact component={DouaneEdit} />
          <Route path="/declaration/:id?" exact component={DouaneDeclaration} />
          <Route path="/users" exact component={UserList} />
          <Route path="/pickings" exact component={PickingList} />
          <Route path="/picking/:id" exact component={Picking} />
          <Route path="/syncs" exact component={SyncList} />
          <Route path="/sync" exact component={Sync} />
          <Route path="/sync/:id" exact component={SyncConfig} />
        </div>
      </Router>
    </div>
  );
};

export default Main;
